/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 
import { Message } from 'view-design';
// 通用 Module 
const state = {
  company: null, // 公司信息
}
const mutations = {
  setCompany(state, data) {
    state.company = data;
  },
}
const getters = {
  getCompany: state => {
    return state.company;
  },
}
const actions = {
  registerExhibition({ }, opt) { // 注册展商
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.auth}/api/Account/Register`, opt).then(data => {
        const regData = data.data; 
        if (regData && regData.successed) { 
          resolve(regData); 
        } 
        if (regData && !regData.successed && regData.errors[0]) { 
          Message.error(regData.errors[0].description);
          resolve(null); 
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 